var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82631 2.10634C9.82631 1.46647 9.30351 0.937471 8.67289 1.04588C5.67307 1.56155 3.31783 4.05169 2.97883 7.13227C2.93242 7.55401 2.59291 7.89927 2.16863 7.89927C1.53709 7.89927 1.17532 8.61894 1.55206 9.12579L2.69535 10.6639C3.38773 11.5954 4.78248 11.5954 5.47486 10.6639L6.61814 9.1258C6.99489 8.61894 6.63312 7.89927 6.00158 7.89927C5.57729 7.89927 5.22672 7.55285 5.29481 7.13406C5.5911 5.3115 6.92981 3.85738 8.6796 3.40868C9.29942 3.24975 9.82631 2.74621 9.82631 2.10634ZM16.9573 5.13463C16.2649 4.20314 14.8701 4.20314 14.1778 5.13463L13.0345 6.67274C12.6577 7.17959 13.0195 7.89927 13.651 7.89927C14.0753 7.89927 14.4259 8.24569 14.3578 8.66447C14.0615 10.487 12.7228 11.9412 10.973 12.3898C10.3532 12.5488 9.82631 13.0523 9.82631 13.6922C9.82631 14.3321 10.3491 14.8611 10.9797 14.7527C13.9795 14.237 16.3348 11.7468 16.6738 8.66626C16.7202 8.24452 17.0597 7.89927 17.484 7.89927C18.1155 7.89927 18.4773 7.17959 18.1005 6.67274L16.9573 5.13463Z",
    fill: "#365644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircular);
export default __webpack_public_path__ + "static/media/Circular.c88da17062f27e212ac2f0b33fdbb74a.svg";
export { ForwardRef as ReactComponent };